const controls = {
  data() {
    return {
      activeDot: 0,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      // watch for current slide
      this.$watch('$refs.carousel.currentSlide', (newSlide) => {
        this.activeDot = newSlide
      })
    },
    handleScroll(index) {
      this.activeDot = index
    },
    handleClick(index) {
      // reset tweens if carousel nav button is clicked again
      this.$refs.carousel.changeSlide(index)
    },
  },
}

export { controls }
